export const withPropsConventionNaming = options => options ? (options.props || options) : {};

